// eslint-disable-next-line import/prefer-default-export
export const defaultDateOptions = {
  weekday: 'long',
  year: 'numeric',
  month: 'long',
  day: 'numeric',
};

export const shortDateOptions = {
  weekday: 'short',
  year: 'numeric',
  month: 'short',
  day: 'numeric',
};

export function parseDate(input) {
  const [year, month, day] = input.split('-');
  // new Date(year, month [, day [, hours[, minutes[, seconds[, ms]]]]])
  return new Date(year, month - 1, day); // NOTE: months are 0-based
}

export function dateToISO(date) {
  const tzoffset = date.getTimezoneOffset() * 60000; // offset in milliseconds
  const localISOTime = (new Date(date - tzoffset)).toISOString().slice(0, -1);
  return localISOTime.split('T')[0];
}

export function generatePastDatesInISO(numberOfDates) {
  const today = new Date();
  const dates = [];
  const priorDate = new Date(today);

  for (let i = 0; i < numberOfDates; i += 1) {
    priorDate.setDate(priorDate.getDate() - 1);
    const newDate = new Date(priorDate);
    dates.push(newDate);
  }

  return dates.map(date => dateToISO(date));
}

export function isSameDate(dateOne, dateTwo) {
  const dateOneString = dateToISO(new Date(dateOne));
  const dateTwoString = dateToISO(new Date(dateTwo));

  return dateOneString === dateTwoString;
}

export function isToday(date) {
  const today = dateToISO(new Date());
  return isSameDate(today, date);
}

export function isYesterday(date) {
  const today = new Date();
  const yesterday = today;
  yesterday.setDate(yesterday.getDate() - 1);
  const yesterdayISO = dateToISO(yesterday);
  return isSameDate(yesterdayISO, date);
}

export function isTomorrow(date) {
  const today = new Date();
  const tomorrow = today;
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowISO = dateToISO(tomorrow);
  return isSameDate(tomorrowISO, date);
}

export function isSameDayOfTheWeek(dateOne, dateTwo) {
  const dayOfTheWeekOne = dateOne.getDay();
  const dayOfTheWeekTwo = dateTwo.getDay();

  return dayOfTheWeekOne === dayOfTheWeekTwo;
}

// If today is Friday (date) and I want the last Wednesday (dayOfWeek index) since today.
// IMPORTANT: If the date falls outside of a 6 day range this breaks.
// E.G: Finding last Friday from this Friday does not work.
export function getLastOccuringDayOfWeekFromDate(date, dayOfWeekIndex) {
  const resultDate = new Date(date);

  resultDate.setDate(date.getDate() - (7 - dayOfWeekIndex + date.getDay()) % 7); // eslint-disable-line

  return resultDate;
}

/* For a given date, get the ISO week number
 *
 * Based on information at:
 *
 *    http://www.merlyn.demon.co.uk/weekcalc.htm#WNR
 *
 * Algorithm is to find nearest thursday, it's year
 * is the year of the week number. Then get weeks
 * between that date and the first day of that year.
 *
 * Note that dates in one year can be weeks of previous
 * or next year, overlap is up to 3 days.
 *
 * e.g. 2014/12/29 is Monday in week  1 of 2015
 *      2012/1/1   is Sunday in week 52 of 2011
 */
export function getWeekNumber(d) {
  // Copy date so don't modify original
  const date = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  // Set to nearest Thursday: current date + 4 - current day number
  // Make Sunday's day number 7
  date.setUTCDate(date.getUTCDate() + 4 - (date.getUTCDay() || 7));
  // Get first day of year
  const yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
  // Calculate full weeks to nearest Thursday
  const weekNo = Math.ceil((((date - yearStart) / 86400000) + 1) / 7);

  // Return array of year and week number
  return [date.getUTCFullYear(), weekNo];
}
